import t from 'prop-types';
import { useDropzone } from 'react-dropzone';

import { Fade, Flex, Box } from '@frontend/components';

import UploadButton from '../UploadButton/UploadButton';

//Note: `activeClassName` does not apply to DropzoneWrapper's Box. Destructed out of `props` to eliminate console.error message.
/*eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars*/
const DropzoneWrapper = ({
  onUpload,
  children,
  useOverlay,
  activeClassName,
  ...props
}) => {
  /*eslint-enable @typescript-eslint/no-unused-vars, no-unused-vars*/
  const { disabled } = props;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onUpload,
    noClick: true,
    noKeyboard: true,
    disabled,
  });

  return (
    <Box
      {...getRootProps()}
      style={{}}
      flex={1}
      maxWidth="100%"
      position="relative"
      {...props}
    >
      {children}
      <input {...getInputProps()} />
      {useOverlay ? (
        <Flex
          as={Fade}
          in={isDragActive}
          unmountOnExit
          position="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          backgroundColor="rgba(0, 0, 0, 0.7)"
          color="white"
          justify="center"
          align="center"
          zIndex={useOverlay.zIndex ?? 'unset'}
        >
          <h2>Drop Files Here</h2>
        </Flex>
      ) : null}
    </Box>
  );
};

const ButtonWrapper = ({ onUpload, children, ...props }) => {
  return (
    <UploadButton onUpload={onUpload} {...props}>
      {children}
    </UploadButton>
  );
};

const PartUploader = ({
  children,
  inline,
  type,
  multiple,
  defaultUnits,
  groupId,
  onUpload,
  useOverlay,
  category,
  supportingFileUpload,
  ...props
}) => {
  const Component = {
    button: ButtonWrapper,
    dropzone: DropzoneWrapper,
  }[type];

  if (!Component) {
    throw `PartUploader: unknown type: ${type}`;
  }

  const handleUpload = (files) => {
    supportingFileUpload
      ? onUpload(files)
      : onUpload({
          file: multiple ? files : Array.isArray(files) ? files[0] : files,
          units: defaultUnits,
          groupId: groupId,
          ...(category && { category }),
        });
  };

  return (
    <Flex flex={1} maxWidth="100%" display={inline ? 'inline-flex' : 'flex'}>
      <Component
        onUpload={handleUpload}
        {...(type === 'dropzone' ? { useOverlay } : null)}
        multiple={multiple}
        {...props}
      >
        {children}
      </Component>
    </Flex>
  );
};

PartUploader.propTypes = {
  children: t.node,
  className: t.string,
  containerClassName: t.string,
  inline: t.bool,
  type: t.oneOf(['dropzone', 'button']),
  multiple: t.bool,
  defaultUnits: t.string,
  supportingFileUpload: t.bool,
  groupId: t.string,
  category: t.string,
  onUpload: t.func.isRequired,
};

PartUploader.defaultProps = {
  type: 'dropzone',
  multiple: false,
};

export default PartUploader;
